// src/components/Navbar.tsx
import React, { useState } from 'react';
import { Navbar, Container, Nav, NavDropdown } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import {
  FaHome, FaUserFriends, FaWater, FaChartBar, FaSignOutAlt, FaUserCircle
} from 'react-icons/fa';
import { useAuth } from '../contexts/AuthContext';
import logo from '../assets/logo.png';

const AppNavbar: React.FC = () => {
  const [expanded, setExpanded] = useState(false);
  const navigate = useNavigate();
  const { user, isAuthenticated, logout } = useAuth();

  const close = () => setExpanded(false);

  const handleLogout = () => {
    logout();
    navigate('/login');
    close();
  };

  return (
    <Navbar bg="primary" variant="dark" expand="lg" fixed="top" expanded={expanded} onToggle={setExpanded} className="shadow-sm">
      <Container>
        <Navbar.Brand as={Link} to="/" onClick={close}>
          <img src={logo} height="30" className="d-inline-block align-top me-2" alt="Logo" />
          Sistema de Água
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="navbar-nav" />
        <Navbar.Collapse id="navbar-nav">
          {isAuthenticated && (
            <Nav className="me-auto">
              <Nav.Link as={Link} to="/dashboard" onClick={close}>
                {FaHome({ className: "me-1" })} Dashboard
              </Nav.Link>

              <NavDropdown title={<span>{FaUserFriends({ className: "me-1" })} Cadastros</span>} id="cadastros-dropdown">
                <NavDropdown.Item as={Link} to="/cadastros/pessoas" onClick={close}>Pessoas</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/cadastros/ligacoes" onClick={close}>Ligações</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/cadastros/tarifas" onClick={close}>Faixas de Excesso</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/cadastros/usuarios" onClick={close}>Usuários</NavDropdown.Item>
              </NavDropdown>

              <NavDropdown title={<span>{FaWater({ className: "me-1" })} Manutenções</span>} id="manutencoes-dropdown">
                <NavDropdown.Item as={Link} to="/manutencoes/leituras" onClick={close}>Leituras</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/manutencoes/movimentos" onClick={close}>Movimentos</NavDropdown.Item>
              </NavDropdown>

              <NavDropdown title={<span>{FaChartBar({ className: "me-1" })} Relatórios</span>} id="relatorios-dropdown">
                <NavDropdown.Item as={Link} to="/relatorios/pessoas" onClick={close}>Pessoas</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/relatorios/ligacoes" onClick={close}>Ligações</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/relatorios/consumo" onClick={close}>Consumo</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/relatorios/faturamento" onClick={close}>Faturamento</NavDropdown.Item>
              </NavDropdown>
            </Nav>
          )}

          <Nav className="ms-auto">
            {isAuthenticated ? (
              <NavDropdown
                title={<span>{FaUserCircle({ className: "me-1" })} {user?.name ?? 'Usuário'}</span>}
                id="user-dropdown"
                align="end"
              >
                <NavDropdown.Divider />
                <NavDropdown.Item onClick={handleLogout}>
                  {FaSignOutAlt({ className: "me-1" })} Sair
                </NavDropdown.Item>
              </NavDropdown>
            ) : (
              <Nav.Link as={Link} to="/login" onClick={close}>Entrar</Nav.Link>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default AppNavbar;
